import React from "react";
import {SortIcon} from "../../../../../../../assests/GmsIcons";

interface TableHeaderProps {
  id: string;
  label: string;
  width?: string;
  sortEnabled?: boolean;
  handleSort: (column: string) => void;
  sortBy?: string;
  sortOrder?: string;
}

const TableHeader: React.FC<TableHeaderProps> = ({ id, label, width, sortEnabled, handleSort, sortBy, sortOrder }) => (
  <th
    id={`${id}-header`}
    className={`tw-px-6 tw-py-2 tw-text-[#6b778c] tw-text-sm tw-font-semibold ${sortEnabled === true ? 'tw-cursor-pointer' : ''}`}
    style={width ? { width } : undefined}
    onClick={() => sortEnabled === true ? handleSort(id) : null}
  >
    <div className={'tw-flex tw-items-center tw-gap-1'}>
      {label}
      {sortEnabled === true ? <div className={'tw-mt-0.5'}><SortIcon sortOrder={sortBy !== id ? null : sortOrder} /></div> : null}
    </div>
  </th>
);

export default TableHeader;